import React, { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { explodeDescription } from '../../utils/helpers';
import { getConversionTypeMessage } from './helper';
import { Link } from 'react-router';
import { JerkmateOfferCardFireIcon } from './JerkmateOfferCardFireIcon';
import { Gtm } from '../../utils/gtm';
import { Payout } from '../reusables';
import { getCircleFlagUrl } from '../reusables/reusablesHelpers/helpers';
import config from '../../config';
const { JERKMATE_NEW_OFFER_TAG_ID } = config;
const createPayoutTypeTag = (payout_type) => {
  switch (payout_type) {
    case 'cpa_flat':
      return 'CPA';
    case 'cpa_both':
      return 'CPA + REV';
    case 'cpa_percentage':
      return 'REV';
    default:
      return '';
  }
};

const JerkmateOfferCard = React.memo((offer) => {
  let { id, name, default_payout, payout_type, epc_affiliation, isCarrousel, modal, approval_status, top_countries, tags } =
    offer;

  const [active, setActive] = useState(false);

  const payoutTypeTag = createPayoutTypeTag(payout_type);

  epc_affiliation = epc_affiliation ? epc_affiliation?.substring(0, 6) : 0;

  default_payout = default_payout ? parseFloat(default_payout)?.toFixed(2) : 0;

  const offerHasNewTag = () => !!tags.find((tag) => tag.id === JERKMATE_NEW_OFFER_TAG_ID.id);
  const [isNew, setIsNew] = useState(false);

  useEffect(() => {
    if (offerHasNewTag(offer)) {
      setIsNew(true);
    }
  }, []);

  const hasTopCountries = () => top_countries !== null && top_countries?.length > 0;
  return (
    <Link
      className={`jerkmate-offer-card ${active ? 'active' : ''} ${modal ? 'modalDiv' : ''}`}
      onClick={() => {
        Gtm.event(`jerkmate page`, 'Click', `${isCarrousel ? 'carrousel_select_offer' : 'modal_select_offer'} - ${id}`);
      }}
      onMouseEnter={() => setActive(true)}
      onMouseLeave={() => setActive(false)}
      onTouchEnd={() => setActive(false)}
      onTouchStart={() => setActive(true)}
      to={`/offers/${id}`}
    >
      <div className="inner-offer-card">
        <div className="offer-title">
          <img alt="Jerkmate" className="jerkmate-icon" src="/img/jerky-offer-head.png" />
          <div className="title-box">
            {isNew ? (
              <div className="new-tag-box">
                <span className="new-tag">NEW</span>
              </div>
            ) : null}
            <div className="top">
              {name}
              <div className={`circle ${approval_status || ''}`} />
            </div>
            <div className="tag grey">
              <strong>ID:</strong> {id}
            </div>
          </div>
        </div>
        <div className="info-offer-box offer-spacing">
          <div className="info-offer">
            <div className="title bold-title-hover">
              Exclusive Offer
              <div className="tag green">{payoutTypeTag}</div>
            </div>
            {explodeDescription(offer.description).customPayout
              ? ReactHtmlParser(explodeDescription(offer.description).customPayout)
              : getConversionTypeMessage(offer)}
            <div className="read-more">
              + <u>Read More</u>
            </div>
          </div>
          <div className="jerky-right">
            <div className="circle" />

            <div className="jerky-inner column">
              <img className="offer-jerky-head" src="/img/offer-jerky-head.png" />
              <img className="offer-jerky-arm-left" src="/img/offer-jerky-arm-left.png" />
              <img className="offer-jerky-arm-right" src="/img/offer-jerky-arm-right.png" />
              <img className="offer-jerky-body" src="/img/offer-jerky-body.png" />
            </div>
          </div>
        </div>
        <div className="info-offer-stats offer-spacing">
          <div className={`stats-left ${!hasTopCountries() ? 'full-width' : ''}`}>
            {epc_affiliation > 0 ? (
              <div className={`epc-box ${!hasTopCountries() ? 'full-width' : ''}`}>
                <div className="title">
                  <div className="left">
                    <div className="bold-title-hover epc">EPC</div>
                    <span>{name}</span>
                  </div>
                  <div className="tag green">{payoutTypeTag}</div>
                  <JerkmateOfferCardFireIcon />
                </div>
                <div className="total-box">
                  <div className="amount">
                    ${epc_affiliation}
                    <span />
                  </div>
                </div>
              </div>
            ) : null}
            <div className="payout-box offer-spacing2">
              <div className="title">
                <div className="left">
                  <svg fill="none" height="22" viewBox="0 0 26 22" width="26" xmlns="http://www.w3.org/2000/svg">
                    <g id="PayoutIco">
                      <path
                        d="M15.0692 16.5799V16.5199C14.9061 16.272 14.8285 15.9775 14.8484 15.6814C14.8683 15.3853 14.9844 15.1038 15.1792 14.8799L15.3792 14.6499C15.5085 14.4923 15.668 14.3621 15.8483 14.267C16.0286 14.1719 16.2261 14.1138 16.4292 14.0961C16.6323 14.0784 16.8369 14.1015 17.0309 14.164C17.225 14.2264 17.4046 14.3271 17.5592 14.4599L19.0992 15.6399L19.3992 15.8699L19.6192 15.6099C20.1392 15.0199 20.6192 14.4199 21.1692 13.8199C21.8025 11.6455 21.7362 9.32693 20.9796 7.19223C20.223 5.05752 18.8145 3.21468 16.9532 1.92432C15.092 0.633961 12.8721 -0.038614 10.6077 0.00171306C8.34325 0.0420401 6.14878 0.793229 4.33464 2.14904C2.52049 3.50486 1.17849 5.39668 0.49841 7.55697C-0.181668 9.71726 -0.165399 12.0367 0.544915 14.1872C1.25523 16.3378 2.62364 18.2106 4.45662 19.5408C6.28961 20.871 8.4944 21.5914 10.7592 21.5999C13.0893 21.6065 15.3577 20.8515 17.2192 19.4499L15.4892 17.1999C15.3379 17.0011 15.1977 16.7942 15.0692 16.5799ZM13.8692 15.0499C13.4029 15.6126 12.7743 16.0178 12.0692 16.2099C12.0018 16.2159 11.9364 16.2357 11.8771 16.2682C11.8177 16.3007 11.7657 16.3451 11.7244 16.3986C11.6831 16.4522 11.6533 16.5137 11.6369 16.5793C11.6205 16.6449 11.6179 16.7132 11.6292 16.7799C11.6292 17.0999 11.6292 17.4199 11.6292 17.7799C11.6366 17.8382 11.6311 17.8974 11.6131 17.9534C11.5951 18.0093 11.5649 18.0606 11.5248 18.1035C11.4847 18.1465 11.4357 18.1801 11.3811 18.2019C11.3266 18.2238 11.2679 18.2333 11.2092 18.2299H10.2092C10.1474 18.2352 10.0853 18.2263 10.0275 18.2041C9.96964 18.1819 9.91759 18.1468 9.87525 18.1016C9.8329 18.0564 9.80136 18.0021 9.78299 17.9429C9.76462 17.8838 9.7599 17.8212 9.76919 17.7599C9.76919 17.5299 9.76919 17.2899 9.76919 17.0599C9.76919 16.5399 9.76919 16.5199 9.24919 16.4499C8.6165 16.364 7.9999 16.1854 7.41919 15.9199C6.95919 15.6999 6.90919 15.5899 7.04919 15.1099C7.18919 14.6299 7.23919 14.3999 7.34919 14.0399C7.45919 13.6799 7.58919 13.5799 7.95919 13.7799C8.58348 14.1025 9.26112 14.3092 9.95919 14.3899C10.4097 14.4544 10.8693 14.3957 11.2892 14.2199C11.4776 14.1678 11.6465 14.0616 11.7752 13.9145C11.9039 13.7674 11.9866 13.5858 12.0132 13.3922C12.0398 13.1986 12.0091 13.0014 11.9249 12.8251C11.8406 12.6487 11.7065 12.5009 11.5392 12.3999C11.3076 12.2159 11.0519 12.0645 10.7792 11.9499C10.0621 11.6726 9.36391 11.3486 8.68919 10.9799C8.16732 10.7225 7.73158 10.3188 7.43507 9.81813C7.13856 9.31742 6.99406 8.74129 7.01919 8.15992C7.04564 7.50302 7.27958 6.87139 7.68743 6.35574C8.09527 5.8401 8.65603 5.46696 9.28919 5.28992C9.83919 5.08992 9.83919 5.09992 9.84919 4.50992V3.97992C9.84919 3.53992 9.92919 3.45992 10.3692 3.44992H10.7692C11.6992 3.44992 11.6992 3.44992 11.6992 4.37992C11.6992 5.03992 11.6992 5.03992 12.3592 5.13992C12.8553 5.22234 13.3391 5.36681 13.7992 5.56992C13.8553 5.58657 13.9073 5.61476 13.9519 5.65269C13.9965 5.69062 14.0327 5.73745 14.0581 5.79018C14.0835 5.84291 14.0976 5.90037 14.0995 5.95888C14.1015 6.01739 14.0911 6.07565 14.0692 6.12992C13.9592 6.52992 13.8492 6.92992 13.7192 7.32992C13.5892 7.72992 13.4792 7.75992 13.1192 7.58992C12.4086 7.2416 11.6188 7.0864 10.8292 7.13992C10.6236 7.14396 10.4205 7.18459 10.2292 7.25992C10.0734 7.30793 9.93438 7.39925 9.82847 7.52324C9.72256 7.64722 9.65408 7.79876 9.63102 7.96019C9.60796 8.12161 9.63127 8.28626 9.69823 8.43494C9.76518 8.58362 9.87303 8.7102 10.0092 8.79992C10.3154 9.0313 10.6519 9.21972 11.0092 9.35992C11.6276 9.59495 12.2319 9.8654 12.8192 10.1699C13.2509 10.3877 13.6284 10.6994 13.924 11.0821C14.2196 11.4648 14.4258 11.9088 14.5274 12.3816C14.6291 12.8543 14.6236 13.3439 14.5115 13.8142C14.3993 14.2846 14.1832 14.7239 13.8792 15.0999"
                        fill="#00BC00"
                        id="Vector"
                      />
                      <path
                        d="M25.0292 11.9799C24.8653 11.8199 24.6556 11.715 24.4292 11.6799C24.2492 11.6799 24.0792 11.8099 23.8392 12.0799L20.0892 16.1799L19.2392 17.1099L18.8292 16.7999C18.0892 16.2699 17.3592 15.7199 16.6192 15.1999C16.4945 15.0962 16.3409 15.0333 16.1792 15.0199C16.0836 15.03 15.9911 15.059 15.9069 15.1054C15.8228 15.1518 15.7487 15.2145 15.6892 15.2899C15.6342 15.3383 15.5839 15.3919 15.5392 15.4499C15.4821 15.5169 15.4508 15.602 15.4508 15.6899C15.4508 15.7779 15.4821 15.863 15.5392 15.9299C15.6692 16.1299 15.8092 16.3299 15.9592 16.5199C16.9392 17.7333 17.9392 18.9366 18.9592 20.1299C19.0042 20.1959 19.0636 20.2509 19.1329 20.2907C19.2021 20.3306 19.2795 20.3542 19.3592 20.3599C19.4473 20.3528 19.5324 20.3245 19.6072 20.2775C19.6821 20.2305 19.7445 20.1662 19.7892 20.0899L25.2192 12.7699C25.4892 12.3999 25.4692 12.2799 25.1092 11.9999"
                        fill="#00BC00"
                        id="Vector_2"
                      />
                    </g>
                  </svg>
                  <span className="bold-title-hover">Payout</span>
                </div>
                <div className="tag green">{payoutTypeTag}</div>
              </div>
              <div className={`payout-total-box ${payoutTypeTag}`}>
                <Payout
                  conversionTypes={offer.conversion_types?.map((ct) => ct.name)}
                  defaultPayout={offer.default_payout}
                  payoutType={offer.payout_type}
                  percentPayout={offer.percent_payout}
                />
              </div>
            </div>
          </div>
          {hasTopCountries() ? (
            <div className="stats-right">
              <div className="title">
                <svg fill="none" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                  <g id="mdi:world">
                    <path
                      d="M8.95 8.695C8.82 8.295 8.445 8 8 8H7.5V6.5C7.5 6.36739 7.44732 6.24021 7.35355 6.14645C7.25979 6.05268 7.13261 6 7 6H4V5H5C5.13261 5 5.25979 4.94732 5.35355 4.85355C5.44732 4.75979 5.5 4.63261 5.5 4.5V3.5H6.5C6.76522 3.5 7.01957 3.39464 7.20711 3.20711C7.39464 3.01957 7.5 2.76522 7.5 2.5V2.295C8.09824 2.53618 8.62912 2.91874 9.04721 3.40992C9.4653 3.9011 9.75815 4.48627 9.90067 5.11536C10.0432 5.74444 10.0312 6.39869 9.8656 7.0221C9.70003 7.64552 9.38587 8.21953 8.95 8.695ZM5.5 9.965C3.525 9.72 2 8.04 2 6C2 5.69 2.04 5.39 2.105 5.105L4.5 7.5V8C4.5 8.26522 4.60536 8.51957 4.79289 8.70711C4.98043 8.89464 5.23478 9 5.5 9M6 1C5.34339 1 4.69321 1.12933 4.08658 1.3806C3.47995 1.63188 2.92876 2.00017 2.46447 2.46447C1.52678 3.40215 1 4.67392 1 6C1 7.32608 1.52678 8.59785 2.46447 9.53553C2.92876 9.99983 3.47995 10.3681 4.08658 10.6194C4.69321 10.8707 5.34339 11 6 11C7.32608 11 8.59785 10.4732 9.53553 9.53553C10.4732 8.59785 11 7.32608 11 6C11 5.34339 10.8707 4.69321 10.6194 4.08658C10.3681 3.47995 9.99983 2.92876 9.53553 2.46447C9.07124 2.00017 8.52005 1.63188 7.91342 1.3806C7.30679 1.12933 6.65661 1 6 1Z"
                      fill="#00BC00"
                      id="Vector"
                    />
                  </g>
                </svg>
                <span className="bold-title-hover">
                  Top
                  <br /> Countries
                </span>
              </div>
              <div className="countries">
                {top_countries?.map((country, i) => (
                  <div className="country" key={i}>
                    <div className="left">
                      <img alt="Jerkmate" src={getCircleFlagUrl(country)} />
                      <span>{country || ''}</span>
                    </div>
                    <JerkmateOfferCardFireIcon />
                  </div>
                ))}
              </div>
            </div>
          ) : null}
        </div>
        <div className="jerkmate-offer-btn offer-spacing2">Choose This Offer</div>
      </div>
      <div className="background-hover-gradient" />
    </Link>
  );
});

export default JerkmateOfferCard;
